import { Button } from '@farol-ds/react'
import { LoginTrigger } from '@jusbrasil-web/shared-bifrost'

import { ViewLockWrapper_ViewerFragment } from '../__generated__/view-lock-wrapper.graphql'
import { LockWall } from '../lock-wall'
import styles from './login-wall.module.scss'

export interface LoginWallProps {
  viewer: ViewLockWrapper_ViewerFragment | null
  loginWarningProps: {
    title: string
    subtitle: string
  }
  eventData?: {
    from_component: string
    feature_code: string
    app_id: string
  }
}

export const LoginWall = (props: LoginWallProps) => {
  const { viewer, loginWarningProps, eventData } = props

  return (
    <LockWall {...loginWarningProps}>
      <LoginTrigger
        isLogged={!!viewer}
        options={{
          eventData: {
            app_id: eventData?.app_id,
            feature_code: eventData?.feature_code,
            from_component: eventData?.from_component,
          },
        }}
      >
        <Button className={styles.loginWallButton} kind="secondary">
          Entrar ou criar conta
        </Button>
      </LoginTrigger>
    </LockWall>
  )
}
